import { render, staticRenderFns } from "./InfoTypesView.vue?vue&type=template&id=026e50c0&scoped=true"
import script from "./InfoTypesView.vue?vue&type=script&lang=js"
export * from "./InfoTypesView.vue?vue&type=script&lang=js"
import style0 from "./InfoTypesView.vue?vue&type=style&index=0&id=026e50c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026e50c0",
  null
  
)

export default component.exports